import React from "react";

// Verification codes are the one email a customer is waiting on, so a spam
// folder costs a signup or a sale. This tells them where to look and how to
// stop it happening again.
//
// The address is here rather than in each page so it changes in one place when
// the shop moves off Gmail.
export const SENDER_ADDRESS = "theresalebazaar@gmail.com";

const MailDeliveryNote = ({ className = "" }) => (
  <div
    className={`border rounded p-3 mt-3 mx-auto ${className}`}
    style={{ maxWidth: "420px", background: "#fbfbfc" }}
  >
    <div className="d-flex align-items-start gap-2">
      <i
        className="bi bi-envelope-exclamation text-secondary mt-1"
        aria-hidden="true"
      ></i>
      <div style={{ fontSize: "14px", lineHeight: "1.6" }}>
        <div className="fw-semibold mb-1">Not in your inbox?</div>
        <div className="text-secondary">
          Check your <b>spam</b> or <b>junk</b> folder &mdash; verification
          codes often land there.
        </div>
        <div className="text-secondary mt-2">
          To make sure you receive ours, add{" "}
          <b style={{ whiteSpace: "nowrap" }}>{SENDER_ADDRESS}</b> to your
          contacts or safe sender list.
        </div>
        <details className="mt-2">
          <summary
            className="text-secondary"
            style={{ cursor: "pointer", fontSize: "13px" }}
          >
            How do I do that?
          </summary>
          <ul
            className="text-secondary ps-3 mt-2 mb-0"
            style={{ fontSize: "13px" }}
          >
            <li>
              <b>Gmail:</b> open the message, click the three dots and choose
              &ldquo;Add to contacts&rdquo;, or drag it from Spam to your inbox.
            </li>
            <li>
              <b>Outlook:</b> Junk &rarr; Not junk, then Settings &rarr; Junk
              email &rarr; Safe senders.
            </li>
            <li>
              <b>Yahoo:</b> open the message and click &ldquo;Not spam&rdquo;.
            </li>
          </ul>
        </details>
      </div>
    </div>
  </div>
);

export default MailDeliveryNote;
